import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85953b16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-card" }
const _hoisted_2 = { class: "detail-header" }
const _hoisted_3 = {
  key: 0,
  class: "detail-count"
}
const _hoisted_4 = {
  key: 0,
  class: "detail-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("h3", null, [
        _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
        (_ctx.count!=null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.count), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Button, {
        label: _ctx.modelValue ? 'Ẩn chi tiết' : 'Hiện chi tiết',
        icon: _ctx.modelValue ? 'pi pi-chevron-up' : 'pi pi-chevron-down',
        class: "p-button-text",
        "aria-expanded": _ctx.modelValue,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', !_ctx.modelValue)))
      }, null, 8, ["label", "icon", "aria-expanded"])
    ]),
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}